import { BezieApp } from "./BezieApp";

export let bezieApp : BezieApp;

export function main(){
    bezieApp = new BezieApp();
    bezieApp.init();
    //UIEvents.initEvents();
    bezieApp.draw();
}